import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';

@Component({
  selector: 'app-column-asset',
  templateUrl: './column-asset.component.html',
  styleUrls: ['./column-asset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnAssetComponent extends ColumnComponent {
  @Input() reset: boolean;
}
